import { render } from "./WriteSmsV2.vue?vue&type=template&id=690fd1dd&scoped=true"
import script from "./WriteSmsV2.vue?vue&type=script&lang=js"
export * from "./WriteSmsV2.vue?vue&type=script&lang=js"

import "./WriteSmsV2.vue?vue&type=style&index=0&id=690fd1dd&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690fd1dd"]])

export default __exports__